import { UserDetails } from '@/common/user-details';

export const GoalsFilter = function (year = 0, period = '', userId = UserDetails.id) {
    this.year   = year;
    this.period = period;
    this.userId = userId;
};